import {WeekdaySelector} from '../../../recurrence/weekday-selector/weekday-selector';

import {WEEKDAY_OPTIONS} from './consts';
import type {
    RecurrenceDueDateFormSetters,
    RecurrenceDueDateFormState,
} from './recurrence-due-date-mode-form-types';

interface Props {
    values: RecurrenceDueDateFormState;
    setters: RecurrenceDueDateFormSetters;
    isDisabled: boolean;
}

export function RecurrenceWeeklyWeekdayPicker(props: Props) {
    return (
        <WeekdaySelector
            selectedDay={
                WEEKDAY_OPTIONS.find((option) => option.value === props.values.weekday)?.value
            }
            onSelect={(value) => {
                props.setters.setWeekday(value);
            }}
            isDisabled={props.isDisabled}
        />
    );
}
